import React, { Fragment, useContext, useEffect, useState } from 'react';
import environmental from '../../../../../images/environment.png';
import social from '../../../../../images/Social_icon.png';
import governance from '../../../../../images/governance_icon.png';
import { withTranslation, useTranslation } from 'react-i18next';
import '../MaterialityAssessment.scss';
import { LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY } from '../../../../../core/constants/common';
import MaterialIssueService from '../../../../../core/service/MaterialIssueService';
import { LoaderContext } from '../../../../../App';
import { BiX, BiPencil, BiCheck, BiInfoCircle, BiChevronDown, BiChevronUp, BiCollapseVertical } from 'react-icons/bi';
import { Button, Form, Modal, OverlayTrigger } from 'react-bootstrap';
import Utils from '../../../../../core/utilities/Utils';
import { toast } from "react-toastify";
import { BsEyeFill } from 'react-icons/bs';
import MaterialityImpactSelectionModal from './MaterialityImpactSelectionModal';

const OmittedIssues = ({ t, filter, prevVersion, viewType, onSuccess, status, onData, filteredData, matType }) => {

    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat.profile.company.id;
    const lsCompanyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
    const [omittedData, setOmittedData] = useState([]);
    const { setLoaderDisplay } = useContext(LoaderContext);

    const [showSelectModal, setShowSelectModal] = useState(false);
    const handleShowSelect = () => setShowSelectModal(true);
    const handleCloseSelect = () => { setShowSelectModal(false); resetValues() };
    const [omittedDataDetails, setOmittedDataDetails] = useState({});
    const [validatedGroupSelect, setValidatedGroupSelect] = useState(false);
    const [versionId, setVersionId] = useState(0);

    const [financialImpact, setFinancialImpact] = useState({
        type: "FINANCIAL",
        range: "",
        likelihood: "",
        reason: ""
    })
    const [materialityImpact, setMaterialityImpact] = useState({
        type: "IMPACT",
        likelihood: "",
        scale: "",
        scope: "",
        irremediability: "",
        reason: ""
    })
    const [importanceImpact, setImportanceImpact] = useState({
        type: "IMPORTANCE",
        scale: "",
        reason: ""
    })
    const [materialityType, setMaterialityType] = useState(lsCompanyInfo.materialityType == 'SINGLE' ? 'Single' : 'Double');
    const [showOmitModal, setShowOmitModal] = useState(false);
    const [omitReason, setOmitReason] = useState('');
    const [validatedGroupOmit, setValidatedGroupOmit] = useState(false);
    const handleShowOmit = () => setShowOmitModal(true);
    const handleCloseOmit = () => { setShowOmitModal(false); resetOmitValues() };
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const handleDescShow = () => { setShowDescriptionModal(true); };
    const handleDescClose = () => { setShowDescriptionModal(false); resetOmitValues() }
    const { k, i18n } = useTranslation();
    const typeOrder = { ENVIRONMENTAL: 1, SOCIAL: 2, GOVERNANCE: 3 };
    const companyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
    const [topicVisiblity, setTopicVisiblity] = useState({});

    useEffect(() => {
        if(matType) {
            setMaterialityType(matType == 'SINGLE' ? 'Single' : 'Double')
        }
        getAllOmittedData();
    }, [filter]);

    useEffect(() => {
        setOmittedData(filteredData);
    }, [filteredData]);

    const getAllOmittedData = () => {
        setLoaderDisplay(true)
        MaterialIssueService.getSelOmitData(filter.year, prevVersion ?? versionId, companyId, filter.category, false,
            companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL').then(res => {
                if (res.status !== 200) return;
                // const sortedData = res.data.topics.sort((a, b) => {
                //     if (typeOrder[a.category] < typeOrder[b.category]) return -1;
                //     if (typeOrder[a.category] > typeOrder[b.category]) return 1;
                //     return a.name.localeCompare(b.name);
                // });
                getAllTopics(res.data.topics)
                // setOmittedData(res.data.topics ?? []);
            }).catch(err => {
                setLoaderDisplay(false);
            });
    };

    const getAllTopics = (omittedData) => {
        setLoaderDisplay(true);
        MaterialIssueService.getParentTopics(filter.category, companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', true).then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            omittedData.forEach(item1 => {
                // Filter array by matching category
                const matchedCategoryItems = res.data.data.filter(item2 => item2.category === item1.category);

                matchedCategoryItems.forEach(item2 => {
                    const localizedContents = findLocalizedContents(item1.code, item2.children);
                    if (localizedContents) {
                        item1.localizedContents = localizedContents;
                    }
                });
            });

            const transformedData = omittedData.map((obj) => transformObject(obj));
            setOmittedData(transformedData ?? []);
            onData(transformedData);
        }).catch(err => {
            setOmittedData([]);
            setLoaderDisplay(false);
        });
    };

    const findLocalizedContents = (code, arr) => {
        // Recursively search for the code within children arrays
        for (const item of arr) {
            if (item.code === code) {
                return item.localizedContents;
            }
            if (item.children && item.children.length > 0) {
                const result = findLocalizedContents(code, item.children);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    };



    const transformObject = (obj) => {
        const transformedObj = { ...obj };
        // Add the translated values to the main object based on languageCode
        if (obj.localizedContents && obj.localizedContents.length > 0) {
            obj.localizedContents.forEach((item) => {
                if (item.fieldName === 'name') {
                    transformedObj[item.languageCode] = item.translatedValue;
                } else if (item.fieldName === 'description') {
                    transformedObj[`${item.languageCode}_description`] = item.translatedValue;
                }
            });
        }
        // Recursively process the children objects
        if (obj.children && obj.children.length > 0) {
            transformedObj.children = obj.children.map((child) => transformObject(child));
        }

        return transformedObj;
    };

    const saveSelectScores = (e) => {
        e.preventDefault();
        if (materialityType == 'Single') {
            if (importanceImpact.scale == '' || importanceImpact.reason == '' || materialityImpact.scale == '' || materialityImpact.reason == '') {
                setValidatedGroupSelect(true);
                toast.warning(t('ChooseMandatoryMessage.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            };
        } else {
            if (financialImpact.reason == '' || financialImpact.range == '' || financialImpact.likelihood == '' || materialityImpact.reason == ''
                || materialityImpact.likelihood == '' || materialityImpact.scale == '' || materialityImpact.scope == '' || materialityImpact.irremediability == '') {
                setValidatedGroupSelect(true);
                toast.warning(t('ChooseMandatoryMessage.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            };
        }
        const passData = omittedDataDetails;
        const masterRef = passData.masterRef ?? 0;
        if (materialityType == 'Single') {
            let matDataToSend = {
                type: "IMPACT",
                scale: materialityImpact.scale,
                reason: materialityImpact.reason
            }
            passData['materialityImpact'] = matDataToSend;
            passData['importanceImpact'] = importanceImpact;
        } else {
            passData['financialImpact'] = financialImpact;
            passData['materialityImpact'] = materialityImpact;
        }
        setLoaderDisplay(true);
        MaterialIssueService.saveSelectedData(filter.year, versionId, companyId, masterRef,
            companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', passData).then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success(t('MatIssueSelectSuccessMsg.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                handleCloseSelect();
                resetValues();
                onSuccess(res);
                getAllOmittedData();
            }).catch(err => {
                setLoaderDisplay(false);
            });
    };

    const resetValues = () => {
        setFinancialImpact({
            type: "FINANCIAL",
            range: "",
            likelihood: "",
            reason: ""
        });
        setMaterialityImpact({
            type: "IMPACT",
            likelihood: "",
            scale: "",
            scope: "",
            irremediability: "",
            reason: ""
        });
        setImportanceImpact({
            type: "IMPORTANCE",
            scale: "",
            reason: ""
        });
        // setMaterialityType('Single');
        setOmittedDataDetails({})
        setValidatedGroupSelect(false);
    }

    const openDetailsModal = (topic) => {
        setOmitReason(topic.comments);
        setOmittedDataDetails(topic)
        handleShowOmit();
    }

    const updateMaterialityScores = (e) => {
        e.preventDefault();
        if (!omitReason) {
            setValidatedGroupOmit(true);
            toast.warning(t('ChooseMandatoryMessage.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        const passData = omittedDataDetails;
        passData['comments'] = omitReason;
        setLoaderDisplay(true);
        MaterialIssueService.updateMateriality(omittedDataDetails.id, companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', passData).then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            toast.success(t('MatIssueUpdateSuccessMsg.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            handleCloseOmit();
            resetOmitValues();
            getAllOmittedData();
        }).catch(err => {
            setLoaderDisplay(false);
        });
    }

    const resetOmitValues = () => {
        setOmitReason('');
        setOmittedDataDetails({});
    }

    const openDescriptionViewModal = (topic) => {
        handleDescShow();
        setOmittedDataDetails(topic);
    }

    const renderSubTopics = (topic) => {
        // topic?.children?.sort((a, b) => a.name.localeCompare(b.name));
        return (
            <>
                <div className='issuesLIbraryCard_body'>
                    <div className='issuesLIbraryCard_body_in'>
                        {
                            topic?.children?.map((subTopic, topicIndex) => {
                                // subTopic?.children?.sort((a, b) => a.name.localeCompare(b.name));
                                return (
                                    <div className='issuesLIbraryCard_sub'>
                                        <div className='issuesLIbraryCard_subhead'>
                                            <div className='issuesLIbraryCard_subheadIn' onClick={() => toggleTopic(subTopic.id)} >
                                                <span className='Libraryactivebtn'>
                                                    {
                                                        topicVisiblity[subTopic.id] === false
                                                            ? <BiChevronDown />
                                                            : <BiChevronUp />
                                                    }
                                                </span>
                                                <h6>
                                                    {(i18n.language && subTopic[i18n.language]) ? subTopic[i18n.language] : subTopic.name}
                                                </h6>
                                            </div>

                                        </div>
                                        <div className='issuesLIbraryCard_subbody'>
                                            <div className='row mx-0'>
                                                {
                                                    topicVisiblity[subTopic.id] !== false &&
                                                    subTopic?.children?.map((subSubTopic, sIndex) => {
                                                        return (
                                                            <div key={`subSubTopic-${topicIndex}-${sIndex}`} className={'col-lg-3 col-md-4 p-2'}>
                                                                <div className={'card p-3 Single_MIC01'}>

                                                                    <div className='Single_MIC01_in'>
                                                                        <div className='Single_MIC01-head' onClick={() => openDescriptionViewModal(subSubTopic)}>
                                                                            {subSubTopic.category === 'ENVIRONMENTAL' && (
                                                                                <div className="Single_MIC01_img environmentalimg">
                                                                                    <img src={environmental} />
                                                                                </div>
                                                                            )}
                                                                            {subSubTopic.category === 'SOCIAL' && (
                                                                                <div className="Single_MIC01_img Socialimg">
                                                                                    <img src={social} />
                                                                                </div>
                                                                            )}
                                                                            {subSubTopic.category === 'GOVERNANCE' && (
                                                                                <div className="Single_MIC01_img governanceimg">
                                                                                    <img src={governance} />
                                                                                </div>
                                                                            )}
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={Utils.renderTooltip(
                                                                                    i18n.language && subSubTopic[i18n.language]
                                                                                        ? subSubTopic[i18n.language]
                                                                                        : subSubTopic.name
                                                                                )}>
                                                                                <h6>
                                                                                    {(i18n.language && subSubTopic[i18n.language] && subSubTopic[i18n.language]) ? subSubTopic[i18n.language] : subSubTopic.name}

                                                                                </h6>
                                                                            </OverlayTrigger>
                                                                            <p>
                                                                                {
                                                                                    (i18n.language && subSubTopic[`${i18n.language}_description`])
                                                                                        ? (subSubTopic[`${i18n.language}_description`]?.length > 50
                                                                                            ? subSubTopic[`${i18n.language}_description`].substring(0, 60) + '...'
                                                                                            : subSubTopic[`${i18n.language}_description`])
                                                                                        : (subSubTopic.description?.length > 50
                                                                                            ? subSubTopic.description.substring(0, 60) + '...'
                                                                                            : subSubTopic.description)
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                        {
                                                                            (viewType == 'edit' && status != 'FINALIZED') &&
                                                                            <div className='comment_singleMateriality'>
                                                                                <ul>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={Utils.renderTooltip(
                                                                                            'Edit omitted reason'
                                                                                        )}>
                                                                                        <li>
                                                                                            <BiPencil className='font-20' onClick={() => openDetailsModal(subSubTopic)} />
                                                                                        </li>
                                                                                    </OverlayTrigger>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={Utils.renderTooltip(
                                                                                            t("SelectIssue.label")
                                                                                        )}>
                                                                                        <li variant="primary">
                                                                                            <BiCheck className='font-22' onClick={() => { handleShowSelect(); setOmittedDataDetails(subSubTopic) }} />
                                                                                        </li>
                                                                                    </OverlayTrigger>
                                                                                </ul>
                                                                            </div>
                                                                        }
                                                                        {
                                                                            (viewType == 'view' || status == 'FINALIZED') &&
                                                                            <div className='comment_singleMateriality'>
                                                                                <ul>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={Utils.renderTooltip(
                                                                                            'View omitted reason'
                                                                                        )}>
                                                                                        <li>
                                                                                            <BsEyeFill className='font-20' onClick={() => openDetailsModal(subSubTopic)} />
                                                                                        </li>
                                                                                    </OverlayTrigger>
                                                                                </ul>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </>
        )
    };

    const toggleTopic = (topicId) => {
        const t = JSON.parse(JSON.stringify(topicVisiblity));
        t[topicId] = t[topicId] !== false ? false : !t[topicId];
        setTopicVisiblity(t);
    };

    const collapseAll = (topic) => {
        const t = JSON.parse(JSON.stringify(topicVisiblity));
        topic.children.forEach(element => {
            t[element.id] = t[element.id] !== false ? false : !t[element.id];;
        });
        setTopicVisiblity(t);
    }

    return (
        <div className='row m-0'>
            <p className='p-2'>
                {t('IssuesAlreadyOmittedMsg.label')}
            </p>
            {/* <div className='row mx-0'>
                {
                    omittedData?.map((topic, index) => {
                        return (
                            <>
                                <div className='col-md-3 p-2'>
                                    <div className='card p-3 Single_MIC01'>
                                        <div className='Single_MIC01-head cursor' onClick={() => openDescriptionViewModal(topic)}>

                                            {topic.category === 'ENVIRONMENTAL' && (
                                                <div className="Single_MIC01_img environmentalimg">
                                                    <img src={environmental} />
                                                </div>
                                            )}
                                            {topic.category === 'SOCIAL' && (
                                                <div className="Single_MIC01_img Socialimg">
                                                    <img src={social} />
                                                </div>
                                            )}
                                            {topic.category === 'GOVERNANCE' && (
                                                <div className="Single_MIC01_img governanceimg">
                                                    <img src={governance} />
                                                </div>
                                            )}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={Utils.renderTooltip(
                                                    i18n.language && topic[i18n.language]
                                                        ? topic[i18n.language]
                                                        : topic.name
                                                )}>
                                                <h6>
                                                    {(i18n.language && topic[i18n.language]) ? topic[i18n.language] : topic.name}
                                                </h6>
                                            </OverlayTrigger>
                                            <p>
                                                {(i18n.language && topic[`${i18n.language}_description`])
                                                    ? (topic[`${i18n.language}_description`]?.length > 50
                                                        ? topic[`${i18n.language}_description`].substring(0, 60) + '...'
                                                        : topic[`${i18n.language}_description`])
                                                    : (topic.description?.length > 50
                                                        ? topic.description.substring(0, 60) + '...'
                                                        : topic.description)}
                                            </p>
                                        </div>
                                        {
                                            (viewType == 'edit' && status != 'FINALIZED') &&
                                            <div className='comment_singleMateriality'>
                                                <ul>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(
                                                            'Edit omitted reason'
                                                        )}>
                                                        <li>
                                                            <BiPencil className='font-20' onClick={() => openDetailsModal(topic)} />
                                                        </li>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(
                                                            t("SelectIssue.label")
                                                        )}>
                                                        <li variant="primary">
                                                            <BiCheck className='font-20' onClick={() => { handleShowSelect(); setOmittedDataDetails(topic) }} />
                                                        </li>
                                                    </OverlayTrigger>
                                                </ul>
                                            </div>
                                        }
                                        {
                                            (viewType == 'view' || status == 'FINALIZED') &&
                                            <div className='comment_singleMateriality'>
                                                <ul>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(
                                                            'View omitted reason'
                                                        )}>
                                                        <li>
                                                            <BsEyeFill className='font-20' onClick={() => openDetailsModal(topic)} />
                                                        </li>
                                                    </OverlayTrigger>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    })
                }
            </div> */}

            <div className={'col-md-12 p-2'}>
                {
                    omittedData?.map((topic, index) => {
                        return (
                            <>
                                <div className={`issuesLIbraryCard 
                                                                ${topic.category === 'ENVIRONMENTAL' ? 'Environmentalcard' :
                                        topic.category === 'SOCIAL' ? 'socialCard' :
                                            topic.category === 'GOVERNANCE' ? 'Governancecard' : ''}`}>

                                    <Fragment key={`topic-${index}`}>
                                        <div className='issuesLIbraryCard_head'>
                                            <div className='issuesLIbraryCard_head_inner'>
                                                <h6>{(i18n.language && topic[i18n.language]) ? topic[i18n.language] : topic.name}</h6>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        t('CollapseOrExpand.label')
                                                    )}>
                                                    <span className='all_collapseBtn' onClick={() => collapseAll(topic)}>
                                                        <BiCollapseVertical />
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                        {renderSubTopics(topic)}
                                    </Fragment >
                                </div >
                            </>
                        )
                    })
                }
            </div >

            <MaterialityImpactSelectionModal
                t={t}
                validated={validatedGroupSelect}
                mode={viewType === 'view' || status === 'FINALIZED' ? 'VIEW' : 'EDIT'}
                topicDetails={omittedDataDetails}
                financialImpact={financialImpact}
                materialityImpact={materialityImpact}
                importanceImpact={importanceImpact}
                onFinancialImpactChange={setFinancialImpact}
                onMaterialityImpactChange={setMaterialityImpact}
                onImportanceImpactChange={setImportanceImpact}
                onClose={handleCloseSelect}
                onSave={saveSelectScores}
                show={showSelectModal}
                materialityType={materialityType}
            />

            <Modal show={showOmitModal}
                onHide={handleCloseOmit}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton className='border-0  SMHead014 '>
                    <Modal.Title bsPrefix="modal-title" as="h5" className='pt-3 px-3 w-100'>
                        <div className='Single_MIC01_02 '>
                            {omittedDataDetails.category === 'ENVIRONMENTAL' && (
                                <div className="Single_MIC01_img_02 environmentalimg">
                                    <img src={environmental} />
                                </div>
                            )}
                            {omittedDataDetails.category === 'SOCIAL' && (
                                <div className="Single_MIC01_img_02 Socialimg">
                                    <img src={social} />
                                </div>
                            )}
                            {omittedDataDetails.category === 'GOVERNANCE' && (
                                <div className="Single_MIC01_img_02 governanceimg">
                                    <img src={governance} />
                                </div>
                            )}
                            {(i18n.language && omittedDataDetails[i18n.language])
                                ? omittedDataDetails[i18n.language]
                                : omittedDataDetails?.name}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={Utils.renderTooltip(
                                    (i18n.language && omittedDataDetails[`${i18n.language}_description`])
                                        ? omittedDataDetails[`${i18n.language}_description`]
                                        : omittedDataDetails?.description
                                )}>
                                <span className='ms-2'><BiInfoCircle /></span>
                            </OverlayTrigger>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validatedGroupOmit}>
                        <div className='pb-3'>
                            <div className='mb-2'>
                                <label>{t('ReasonForOmittingText.label')} <span className='text-danger'>*</span></label>
                                <textarea className='form-control' rows={5}
                                    value={omitReason}
                                    onChange={(e) => setOmitReason(e.target.value)}
                                    required disabled={viewType == 'view' || status == 'FINALIZED'}
                                    maxLength={2000}>
                                </textarea>
                            </div>
                            {
                                (viewType == 'edit' && status != 'FINALIZED') &&
                                <div className='text-center pt-3 '>
                                    <Button variant="secondary" className='me-2 px-3' onClick={() => {
                                        handleCloseOmit();
                                    }}>
                                        {t("Close.label")}
                                    </Button>
                                    <Button variant="primary" className='px-3' onClick={(e) => updateMaterialityScores(e)}>
                                        {t("Update.label")}
                                    </Button>
                                </div>
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <Modal show={showDescriptionModal}
                onHide={handleDescClose}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered>
                <Modal.Header closeButton className='bg-white border-0 pt-3 SMHead014'>
                    <Modal.Title className='pt-3 px-3'>
                        <div className='Single_MIC01_02'>
                            {omittedDataDetails.category === 'ENVIRONMENTAL' && (
                                <div className="Single_MIC01_img_02 environmentalimg">
                                    <img src={environmental} />
                                </div>
                            )}
                            {omittedDataDetails.category === 'SOCIAL' && (
                                <div className="Single_MIC01_img_02 Socialimg">
                                    <img src={social} />
                                </div>
                            )}
                            {omittedDataDetails.category === 'GOVERNANCE' && (
                                <div className="Single_MIC01_img_02 governanceimg">
                                    <img src={governance} />
                                </div>
                            )}
                            {(i18n.language && omittedDataDetails[i18n.language])
                                ? omittedDataDetails[i18n.language]
                                : omittedDataDetails?.name}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pt-0'>
                    <div className='pb-3'>
                        <div className=''>
                            <p>
                                {(i18n.language && omittedDataDetails[`${i18n.language}_description`])
                                    ? omittedDataDetails[`${i18n.language}_description`]
                                    : omittedDataDetails?.description
                                }
                                {/* {omittedDataDetails?.description} */}
                            </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
};

export default withTranslation()(OmittedIssues);